import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IMyMonitoringCompleteUserModel } from '@apps-common/types/portal/users'

export const QUERY_MY_MONITORING_GET_SITE_USERS = (unitId?: string) => ['getMyMonitoringSiteUsers', unitId].filter(Boolean)

const getUnitSiteUsers = async (unitId: string): Promise<IMyMonitoringCompleteUserModel> =>
  axios.get(`/my-monitoring/sites/GetUsers?unitId=${unitId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitSiteUsers

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId: string
}

export const useMyMonitoringGetSiteUsers = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_MY_MONITORING_GET_SITE_USERS(unitId),
    queryFn: () => getUnitSiteUsers(unitId)
  })
